module.exports = __webpack_public_path__ + "sd.svg?aafc9cae603296bc1a353c32c9d0f8f2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/sd.svg
// module id = 1345
// module chunks = 0